
import * as THREE from 'three';
import Phobject from './Phobject.js'
export default class CoffeeTable extends Phobject {
    constructor(){
        super(true);
        this.build()
    }

    build(){
        let toM = function(n){
            return n/39.37;
        }
        this.dimTable = new THREE.Vector2(toM(29),toM(27)); //diameter, height

        this.group = new THREE.Group();

        // pages are a boxgeo

        // front, back, and spine are plane geo
        //var texture = new THREE.TextureLoader().load( imagePath );
        
        // Table top
        var geoTop = new THREE.CylinderGeometry( this.dimTable.x, this.dimTable.x, toM(1), 50, 2);
        var matWood = new THREE.MeshPhongMaterial( {color: 0xFFFFFF, side: THREE.DoubleSide});
        let meshTop = new THREE.Mesh( geoTop, matWood );
        meshTop.position.y = this.dimTable.y/2-toM(1)/2;
        
        // table base
        var geoBase = new THREE.CylinderGeometry( this.dimTable.x/15, this.dimTable.x/5, this.dimTable.y, 30, 2);
        let meshBase = new THREE.Mesh( geoBase, matWood );
        //meshBase.position.y = this.dimTable.y/2;

        this.group.add(meshTop);
        this.group.add(meshBase);
    }

    getObject(){
        return this.group;
    }

    setupPhysics(pos){
        this.group.position.copy(pos);
        // physics
        var options = {
            type:'cylinder',
            size:[this.dimTable.x,this.dimTable.y+.03], // radius, height
            pos:[pos.x,pos.y,pos.z],
            density:5,
            move:this.move
        }
    
        this.phobject = this.world.add( options );
    }
}
